import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=35d85458&"
import script from "./DatePicker.vue?vue&type=script&setup=true&lang=js&"
export * from "./DatePicker.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports